import { ChangeDetectorRef, Pipe, PipeTransform, inject } from '@angular/core';
import { SettingsService } from '../services';
import { AsyncPipe } from '@angular/common';
import { map } from 'rxjs/operators';
import { Settings } from 'src/services/settings.service';

@Pipe({
  name: 'unit',
  pure: false,
})
export class UnitPipe implements PipeTransform {
  private readonly settingsService = inject(SettingsService);
  private readonly cdr = inject(ChangeDetectorRef);

  private _parametersUnitTypes: Record<string, string> = {
    distanceA: 'lengthUnit',
    distanceB: 'lengthUnit',
    distanceC: 'lengthUnit',
    radius1: 'lengthUnit',
    radius2: 'lengthUnit',
    millingDepth: 'lengthUnit',
    massOfRotor: 'weightUnit',
    mass: 'weightUnit',
    weightAmount: 'weightUnit',
    dynamicTolerancePerPlane: 'unbalUnit',
    momentTolerance: 'unbalUnit',
    staticTolerance: 'unbalUnit',
    balancingQualityGrade: 'rotationUnit',
    balancingSpeed: 'rotationUnit',
    serviceSpeed: 'rotationUnit',
    speedWindow: 'rotationUnit',
    speed: 'rotationUnit',
  };

  public transform(value: number | string, parameter: string): string | number | null {
    const parameterUnitType = this._parametersUnitTypes[parameter];

    if (parameter === 'deviation') {
      return `${value} %`;
    }

    if (!parameterUnitType || value === '-') {
      return value;
    }

    const updatedParameter$ = this.settingsService.settings$.pipe(
      map((settings: Settings) => {
        const parameterUnit = settings.unitSettings.units[parameterUnitType];

        return parameterUnit ? `${value} ${parameterUnit}` : value;
      })
    );

    return new AsyncPipe(this.cdr).transform(updatedParameter$);
  }
}
